'use client'

import { Clock, RotateCcw } from 'lucide-react'
import type { ModuleDocument } from '@/hooks/use-module-documents'

// Panneau « Historique récent (48 h) » réutilisable par les modules
// Codification, Rapport et Note technique. Chaque entrée peut être rouverte
// (le module restaure le contenu dans son état de résultat, ce qui réactive
// ses boutons d'export existants).
interface ModuleHistoryPanelProps {
  history: ModuleDocument[]
  accent: string
  /** Libellé de l'unité affichée (ex. « rapport », « codification »). */
  noun?: string
  onReopen: (doc: ModuleDocument) => void
}

export default function ModuleHistoryPanel({ history, accent, noun = 'document', onReopen }: ModuleHistoryPanelProps) {
  if (history.length === 0) return null

  return (
    <div style={{ border: '1px solid #E5E7EB', borderRadius: 10, overflow: 'hidden', marginTop: 16 }}>
      <div style={{ padding: '10px 14px', background: '#F9FAFB', borderBottom: '1px solid #E5E7EB', display: 'flex', alignItems: 'center', gap: 7 }}>
        <Clock size={14} color={accent} />
        <span style={{ fontSize: 12, fontWeight: 700, color: '#374151' }}>Historique récent</span>
        <span style={{ fontSize: 11, color: '#6B7280' }}>— 48 dernières heures</span>
      </div>
      <div>
        {history.map((doc, idx) => (
          <div key={doc.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '10px 14px', borderBottom: idx < history.length - 1 ? '1px solid #F3F4F6' : 'none' }}>
            <div style={{ minWidth: 0, flex: 1 }}>
              <p style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {doc.title || `Sans titre`}
              </p>
              <p style={{ fontSize: 11, color: '#6B7280', margin: '2px 0 0' }}>
                {new Date(doc.created_at).toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                {typeof doc.word_count === 'number' && doc.word_count > 0 ? ` · ${doc.word_count.toLocaleString('fr-FR')} mots` : ''}
              </p>
            </div>
            <button
              type="button"
              onClick={() => onReopen(doc)}
              title={`Rouvrir ce ${noun}`}
              style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '6px 11px', fontSize: 12, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer', border: `1px solid ${accent}50`, borderRadius: 7, background: `${accent}10`, color: accent, flexShrink: 0 }}
            >
              <RotateCcw size={12} /> Rouvrir
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
